'use strict';

export default class ModalActions {
    constructor() {
        this.generateActions(
            'openModal',
            'closeModals',
            'activateLoading',
            'disableLoading',
            'openMediaModal',
            'openInstantDownloadModal',
            'openInstantDownloadAllModal',
            'confirmModal',
            'toggleDownload',
            'setSelectedItemId',
            'toggleDownloadAll',
            'generateDownload',
            'openWatermarkModal',
            'setModalInModal',
            'setSelectedForFileKey',
            'openExcelSearchModal'
        );
    }
}


// WEBPACK FOOTER //
// ./app/actions/modalActions.js